import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "plus",
  "use": "plus-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"plus\"><path d=\"M23.99 11.07l-11.13.07V.01h-1.72v11.14L0 11.22l.01 1.71 11.13-.07v11.13h1.72V12.85L24 12.78l-.01-1.71z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol